import { useMemo } from "react";
import { getColorFromCssVariable } from "ui";
import { LineChartCard } from "./shared/LineChartCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type DeclinesData = {
  value: number;
  label: string;
}[];

export function TotalDeclinesChart() {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<DeclinesData>({
      chartType: "TOTAL_DECLINES",
    });

  const { labels, declinesData } = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0)
      return { labels: [], declinesData: [] };

    return {
      labels: data.map((item) => item.label),
      declinesData: data.map((item) => item.value),
    };
  }, [data]);

  const color = useMemo(() => getColorFromCssVariable("--chart-danger"), []);

  return (
    <LineChartCard
      ref={ref}
      title="Total declines"
      description="Volume of failed payment attempts per day in the selected period."
      format="number"
      labels={labels}
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
      datasets={[
        {
          label: "Declines",
          data: declinesData,
          backgroundColor: color,
          borderColor: color,
        },
      ]}
    />
  );
}
